<template>
  <!-- <v-app id="inspire">
    <v-navigation-drawer v-model="drawer" app>
      <v-list dense>
        <v-list-item
          v-for="item in routes"
          :key="item.id"
          :to="item.link"
          @click="checkiflogout(item.link)"
        >
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>{{ item.text }}</v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar color="blue-grey darken-4" dark fixed>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-app-bar-title>{{
        settings && settings.shop ? settings.shop.name : "Adeton POS"
      }}</v-app-bar-title>
      <v-spacer></v-spacer>
      <v-btn
        text
        :to="{ name: 'admin.dashboard' }"
        v-if="current_userRole == 'administrator'"
      >
        <v-icon>arrow_back</v-icon>Back To Admin
      </v-btn>
      <h3>(ACCOUNTS)</h3>
      <v-btn icon @click="signout()">
        <v-icon>settings_power</v-icon>
      </v-btn>
    </v-app-bar>
    <v-main>
      <v-container
        grid-list-md
        text-xs-center
        style="background: #8080802e"
        class="fill-height"
      >
        <router-view></router-view>
      </v-container>
    </v-main>
    <v-footer color="black" app>
      <span class="white--text">&copy; GoPear Technologies (0506340523)</span>
    </v-footer>
  </v-app> -->

  <v-app id="inspire">
    <v-navigation-drawer v-model="drawer" app>
      <v-list dense>
        <v-list-item v-for="item in routes" :key="item.id" :to="item.link" @click="checkiflogout(item.link)">
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            {{ item.text }}
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar color="blue-grey darken-4" dark fixed app>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-app-bar-title>{{
        settings && settings.shop ? settings.shop.name : "Adeton POS"
      }}</v-app-bar-title>
      <v-spacer></v-spacer>
       <v-btn
        text
        :to="{ name: 'admin.dashboard' }"
        v-if="current_userRole == 'administrator'"
      >
        <v-icon>arrow_back</v-icon>Back To Admin
      </v-btn>
      <h3>(ACCOUNTS)</h3>
      <v-btn icon @click="signout()">
        <v-icon>settings_power</v-icon>
      </v-btn>
    </v-app-bar>
     <v-main style="background:#8080802e">
      <v-container grid-list-md text-xs-center  class="fill-height">
        <router-view> </router-view>
      </v-container>
    </v-main>
    <v-footer color="black" app>
      <span class="white--text">&copy; GoPear Technologies (0506340523)</span>
    </v-footer>
  </v-app>
</template>
<style>
@media print {
  /* @page {
            size: A4;
        }
        body * {
            visibility: hidden;
        }
        #printer-content,
        #printer-content * {
            visibility: visible;
        }
        #printer-content {
            position: absolute;
            left: 0;
            top: 0;
        } */

  .noprint {
    display: none;
  }
}
</style>
<script>
import { mapGetters } from "vuex";
export default {
  data: () => ({
    drawer: false,
    current_userRole: "",
    routes: [
      {
        id: 1,
        icon: "library_books",
        text: "Dashboard",
        link: "/accountant/dashboard",
      },
      {
        id: 12,
        icon: "money",
        text: "Debtors",
        link: "/debtors",
      },

      {
        id: 4,
        icon: "money",
        text: "Expense",
        link: "/accountant/expense",
      },
      {
        id: 13,
        icon: "money",
        text: "Banking",
        link: "/accountant/banking",
      },

      {
        id: 2,
        icon: "money",
        text: "Ledger Accounts",
        link: "/accountant/ledgeracc",
      },
      {
        id: 5,
        icon: "description",
        text: "Reports",
        link: "/reports",
      },

      {
        id: 10,
        icon: "settings_power",
        text: "Exit",
        link: "/login",
      },
    ],
  }),
  props: {
    source: String,
  },
  computed: {
    ...mapGetters({
      settings: "settings/SETTINGS",
    }),
  },
  created() {
    this.$store.dispatch("settings/getAll");
    let { user_details } = this.$store.getters["Auth/CURRENT_USER"];

    this.current_userRole = user_details.role;
  },
  methods: {
    signout() {
      var vm = this;

      this.$store.dispatch("Auth/logout");
      vm.$router.push("/");
    },
    setLayout(layout) {
      this.$store.dispatch("Layouts/set_layout", layout);
    },
    checkiflogout(link) {
      if (link == "/login") {
        this.setLayout("simple-layout");
      }
    },
  },
};
</script>